import React, { useState, useContext } from "react";
import { CubeJSContext } from '../../context/CubeJSProvider';
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import TextFieldComponent from '../../components/TextFieldComponent';
import MultiSelectComponent from '../../components/MultiSelectComponent';
import DateRangePickerComponent from '../../components/DateRangePickerComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { format } from 'date-fns'

const applyFilter = (query, membershipCodeFilter, emailFilter, phoneFilter, 
    userNameFilter, zoneFromPSFilter, userAgreementPicsFilter, userAgreementTermsFilter, storeCodeFilter) => {

  let membershipCodeFilterObj = {
    member: "OrderUsers.membershipCode",
    operator: "contains",
    values: [membershipCodeFilter]
  }


  if (membershipCodeFilter !== '') {
    query = {
      ...query,
      filters: (query.filters || []).concat(membershipCodeFilterObj)
    }
  }

  let emailFilterObj = {
    member: "OrderUsers.userEmail",
    operator: "contains",
    values: [emailFilter]
  }


  if (emailFilter !== '') {
    query = {
      ...query,
      filters: (query.filters || []).concat(emailFilterObj)
    }
  }

  let phoneFilterObj = {
    member: "OrderUsers.phone",
    operator: "contains",
    values: [phoneFilter]
  }


  if (phoneFilter !== '') {
    query = {
      ...query,
      filters: (query.filters || []).concat(phoneFilterObj)
    }
  }

  let userNameFilterObj = {
    member: "OrderUsers.firstName",
    operator: "contains",
    values: [userNameFilter]
  }


  if (userNameFilter !== '') {
    query = {
      ...query,
      filters: (query.filters || []).concat(userNameFilterObj)
    }
  }

  let zoneFromPSFilterObj = {
    member: "OrderUsers.zonePS",
    operator: "contains",
    values: [zoneFromPSFilter]
  }


  if (zoneFromPSFilter !== '') {
    query = {
      ...query,
      filters: (query.filters || []).concat(zoneFromPSFilterObj)
    }
  }

  let userAgreementPicsFilterObj = {
    member: "OrderUsers.userAgreementPics",
    operator: "contains",
    values: userAgreementPicsFilter
  }
  query = {
    ...query,
    filters: (query.filters || []).concat(userAgreementPicsFilterObj)
  }

  let userAgreementTermsFilterObj = {
    member: "OrderUsers.userAgreementTerms",
    operator: "contains",
    values: userAgreementTermsFilter
  }
  query = {
    ...query,
    filters: (query.filters || []).concat(userAgreementTermsFilterObj)
  }

  let storeCodeFilterObj = {
    member: "OrderUsers.shipmentStoreCode",
    operator: "equals",
    values: storeCodeFilter
  }
  query = {
    ...query,
    filters: (query.filters || []).concat(storeCodeFilterObj)
  }

  return query
}

const OrderUserExportQuery = (membershipCodeFilter, emailFilter, phoneFilter, 
    userNameFilter, zoneFromPSFilter, userAgreementPicsFilter, userAgreementTermsFilter, storeCodeFilter,
    startDateFilter, endDateFilter, isRefresh, setRefresh) => {
  const { t } = useTranslation();
  let item = {
    name: t('page.rt.rtOrderUserExport.name'),
    tableHeaders: {
      "OrderUsers.referenceNumber":  { name: t('page.rt.rtOrderUserExport.tableHeader.referenceNumber'), type: "string" },
      "OrderUsers.shipmentStoreCode":  { name: t('page.rt.rtOrderUserExport.tableHeader.shipmentStoreCode'), type: "string" },
      "OrderUsers.completedAt":  { name: t('page.rt.rtOrderUserExport.tableHeader.completedAt'), type: "dateTime" },
      "OrderUsers.totalPrice":  { name: t('page.rt.rtOrderUserExport.tableHeader.totalPrice'), type: "number" },
      "OrderUsers.membershipCode":  { name: t('page.rt.rtOrderUserExport.tableHeader.membershipCode'), type: "string" },
      "OrderUsers.firstName":  { name: t('page.rt.rtOrderUserExport.tableHeader.firstName'), type: "string" },
      "OrderUsers.sex":  { name: t('page.rt.rtOrderUserExport.tableHeader.sex'), type: "string" },
      "OrderUsers.userEmail":  { name: t('page.rt.rtOrderUserExport.tableHeader.userEmail'), type: "string" },
      "OrderUsers.phone":  { name: t('page.rt.rtOrderUserExport.tableHeader.phone'), type: "string" },
      "OrderUsers.customerRankCode":  { name: t('page.rt.rtOrderUserExport.tableHeader.customerRankCode'), type: "string" },
      "OrderUsers.rankExpireAt":  { name: t('page.rt.rtOrderUserExport.tableHeader.rankExpireAt'), type: "dateTime" },
      "OrderUsers.zonePS":  { name: t('page.rt.rtOrderUserExport.tableHeader.zonePS'), type: "string" },
      "OrderUsers.userAgreementPics":  { name: t('page.rt.rtOrderUserExport.tableHeader.userAgreementPics'), type: "string" },
      "OrderUsers.userAgreementTerms":  { name: t('page.rt.rtOrderUserExport.tableHeader.userAgreementTerms'), type: "string" }
    },
    grid: {xs: 12, lg: 12},
    export: { allowExport: true, filename: 'rt_order_user_export_' + format(new Date(), 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.orders.RtOrderUser.query,
    "timeDimensions": OmnitechQueries.orders.RtOrderUser.query.timeDimensions.concat(
      {
        "dimension": "OrderUsers.completedAt",
        "dateRange": [ startDateFilter, endDateFilter ]
      })
  }
  query = applyFilter(query, membershipCodeFilter, emailFilter, phoneFilter, 
    userNameFilter, zoneFromPSFilter, userAgreementPicsFilter, userAgreementTermsFilter, storeCodeFilter)
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const RtOrderUserExportPage = () => {
  const { t } = useTranslation();
  const context = useContext(CubeJSContext);
  let storeCodeSelect = []
  if(context.storeCodes)
    storeCodeSelect = context.storeCodes
  const [ storeCodeFilter, setStoreCodeFilter ] = useState([]);
  const [ membershipCodeFilter, setMembershipCodeFilter ] = useState('');
  const [ emailFilter, setEmailFilter ] = useState('');
  const [ phoneFilter, setPhoneFilter ] = useState('');
  const [ userNameFilter, setUserNameFilter ] = useState('');
  const [ zoneFromPSFilter, setZoneFromPSFilter ] = useState('');
  let userAgreementPicsSelect = ['yes','no']
  const [ userAgreementPicsFilter, setUserAgreementPicsFilter ] = useState([]);
  let userAgreementTermsSelect = ['true','false']
  const [ userAgreementTermsFilter, setUserAgreementTermsFilter ] = useState([]);
  let filterStartDate = new Date()
  filterStartDate.setHours(0,0,0,0);
  let filterEndDate = new Date()
  filterEndDate.setHours(23,59,59,999);
  const [dateRangeFilter, setDateRangeFilter] = useState([filterStartDate, filterEndDate])
  const [startDateFilter, endDateFilter] = dateRangeFilter
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const { item, result }  = OrderUserExportQuery(membershipCodeFilter, emailFilter, phoneFilter, 
    userNameFilter, zoneFromPSFilter, userAgreementPicsFilter, userAgreementTermsFilter, storeCodeFilter,
    startDateFilter, endDateFilter, refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.rtOrderUserExport')} />,
    <Dashboard>
      <DateRangePickerComponent state={dateRangeFilter} stateChanger={setDateRangeFilter} 
      pageChangerArr={[setPage]}
      startDateLabel={t('page.rt.rtOrderUserExport.filter.orderCompletedAt.startDate')} 
      toLabel={t('page.rt.rtOrderUserExport.filter.orderCompletedAt.to')} 
      endDateLabel={t('page.rt.rtOrderUserExport.filter.orderCompletedAt.endDate')}/>
      <TextFieldComponent id={"membership_code_filter"} state={membershipCodeFilter} pageChangerArr={[setPage]}
        stateChanger={setMembershipCodeFilter} textLabel={t('page.rt.rtOrderUserExport.filter.membershipCode')}/>
      <TextFieldComponent id={"email_filter"} state={emailFilter} pageChangerArr={[setPage]}
        stateChanger={setEmailFilter} textLabel={t('page.rt.rtOrderUserExport.filter.email')}/>
      <TextFieldComponent id={"phone_filter"} state={phoneFilter} pageChangerArr={[setPage]}
        stateChanger={setPhoneFilter} textLabel={t('page.rt.rtOrderUserExport.filter.phone')}/>
      <TextFieldComponent id={"name_filter"} state={userNameFilter} pageChangerArr={[setPage]}
        stateChanger={setUserNameFilter} textLabel={t('page.rt.rtOrderUserExport.filter.userName')}/>
      <TextFieldComponent id={"zone_from_ps_filter"} state={zoneFromPSFilter} pageChangerArr={[setPage]}
        stateChanger={setZoneFromPSFilter} textLabel={t('page.rt.rtOrderUserExport.filter.zoneFromPS')}/>
      <MultiSelectComponent id={"store_code_filter"} state={storeCodeFilter} pageChangerArr={[setPage]}
        stateChanger={setStoreCodeFilter} textLabel={t('page.rt.rtOrderUserExport.filter.storeCode')} selectArray={storeCodeSelect}/>
      <MultiSelectComponent id={"user_agreement_pics_filter"} state={userAgreementPicsFilter} pageChangerArr={[setPage]}
        stateChanger={setUserAgreementPicsFilter} textLabel={t('page.rt.rtOrderUserExport.filter.userAgreementPics')} selectArray={userAgreementPicsSelect}/>
      <MultiSelectComponent id={"user_agreement_terms_filter"} state={userAgreementTermsFilter} pageChangerArr={[setPage]}
        stateChanger={setUserAgreementTermsFilter} textLabel={t('page.rt.rtOrderUserExport.filter.userAgreementTerms')} selectArray={userAgreementTermsSelect}/>
    </Dashboard>
    ,
    <Dashboard>
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default RtOrderUserExportPage;